export default {
  // Floating button
  'chatbot.buttonLabel': '문의하기',

  // Header
  'chatbot.headerTitle': 'GB CosPack Assistant',
  'chatbot.headerSubtitle': '용기 선택, 견적, 주문 과정을 도와드립니다.',

  // Welcome message
  'chatbot.welcomeMessage': '안녕하세요. 화장품 용기 선택, 견적 요청, AI 후가공 미리보기, 주문 절차에 대해 도와드릴 수 있습니다.',

  // Starter questions
  'chatbot.starter.0': '견적 요청은 어떻게 하나요?',
  'chatbot.starter.1': 'MOQ는 어떻게 적용되나요?',
  'chatbot.starter.2': 'AI 후가공 미리보기는 무엇인가요?',
  'chatbot.starter.3': '주문 상태는 어디에서 확인하나요?',

  // Input
  'chatbot.inputPlaceholder': '메시지를 입력하세요...',
  'chatbot.send': '보내기',
  'chatbot.close': '닫기',
  'chatbot.newChat': '새 대화',

  // Loading
  'chatbot.loading': '답변을 생성하는 중...',

  // Error
  'chatbot.errorMessage': '일시적으로 답변을 생성하지 못했습니다. 잠시 후 다시 시도해 주세요.',
  'chatbot.notConfigured': '챗봇 API가 아직 연결되지 않았습니다. 관리자에게 백엔드 URL 설정을 요청해 주세요.',

  // Safety status
  'chatbot.outOfScopeNote': '화장품 용기, 견적, 주문 관련 질문을 입력해 주세요.',

  // Quote CTA
  'chatbot.quoteCta': '견적 요청',
  'chatbot.suggestedQuestions': '추천 질문',
};